import React from "react";
import { connect } from "react-redux";
import { useIntl } from "react-intl";
import { useField } from "react-final-form";
import mapCodesToOptions from "../../utils/secret-questions/map-codes-to-options";
import { getSecretQuestions } from "../../store/secret-questions";
import SecretQuestionAnswer from "../secret-question-answer";
import DropdownWrapper from "../dropdown-wrapper";
import messages from "./secret-question-select-messages";

const SecretQuestionSelect = ({ secretQuestions }) => {
  const { formatMessage } = useIntl();
  const label = formatMessage(messages.label);
  const items = mapCodesToOptions(
    secretQuestions
  ).map(({ message, ...rest }) => ({ label: formatMessage(message), ...rest }));

  const { input } = useField("secretQuestionCode", {
    defaultValue: items[0].value
  });
  const selectedQuestion =
    (input.value && items.find(({ value }) => value === input.value)) ||
    items[0];

  const { input: questionInput } = useField("secretQuestion", {
    defaultValue: selectedQuestion.question
  });
  return (
    <>
      <DropdownWrapper
        items={items}
        onChange={({ value, question }) => {
          input.onChange(value);
          questionInput.onChange(question);
        }}
        dropdownLabel={label}
        selected={selectedQuestion}
        styleType="standard"
        id="secret-question-select"
      />
      <SecretQuestionAnswer secretQuestionCode={selectedQuestion.value} />
    </>
  );
};

const mapStateToProps = state => ({
  secretQuestions: getSecretQuestions(state)
});

export { SecretQuestionSelect };
export default connect(mapStateToProps)(SecretQuestionSelect);
